import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { NewPost } from 'src/app/libs/proto/forum_pb';

@Injectable({
  providedIn: 'root'
})
export class NewPostConversionService{

  constructor(){}

  ToStorage(req: NewPost) {
    const w = new BinaryWriter();
    NewPost.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (newPost: NewPost, errorConvert: any) => void) {
    try {
      callback( NewPost.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(newPost: NewPost[]) {
    const rets = new Array<Uint8Array | number[]>();

    newPost.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }
  FromStorages(data: any, callback: (newPost: NewPost[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<NewPost>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = NewPost.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }


}
